export default {
    nodata:"暂无内容",
    contact:"联系我们",
    load_txt:"加载中...",
    //底部导航
    offiaccount:"UPS 阿帕公众号",
    miniprogram:"UPS阿帕小程序",
    miniprogram_scan:"扫码查看小程序",
    miniprogram_car:"阿帕车主小程序",
    foot_1:"车灯挑选 | 到店安装 | 最新资讯 | 订单服务",
    foot_2:"保修查询",
    foot_3:"安亿仕工厂",
    foot_4:"阿帕品牌",
    foot_5:"门店查询",
    foot_6:"招商加盟",
    wx_name:"官方微信",
    dy_name:"官方抖音",
    wb_name:"官方微博",
    //组件
    btn_detail:"了解详情",
    top_txt_seat:"当前位置",
    
    pay_txt:"立即购买",
    manual_txt:"技术手册下载",
    goods_detail_1:"产品详情",
    goods_detail_2:"名称",
    goods_detail_3:"参数",

    store_input:"请选择输入门店名称",
    store_locate:"目前无法获取您的地理位置，请检查网络和定位服务。",
    store_locate_btn:"重新定位",
    store_phone:"电话",
    store_time:"营业时间",
    
    //按钮
    btn_search:"查询",
    btn_cancel:"取消",
    //信息
    phone:"手机号",
    barcode:"条码",
    input_select:"请选择",

   //质保查询

    warranty_no:"查无该条码商品",
    warranty_input:"请输入产品序列号或安装手机号",
    warranty_input2:"请输入车牌号",
    warranty_title:"保修查询",

    warranty_name:"产品",
    warranty_price:"零售价",
    warranty_barcode:"产品编码",
    warranty_querytime:"首次查询",
    warranty_carmodel:"安装车型",
    warranty_storename:"安装门店",
    installtime:"安装时间",
    storesphone:"门店电话",
    storeaddress:"门店地址",

    warranty_scan1:"扫码查看详情",
    warranty_scan2:"扫码查看我的质保",
    warranty_result:"查询结果",

    warranty_status1:"安装状态",
    warranty_status2:"保修期",
    warranty_status_result1:"未安装",
    warranty_status_result2:"已安装",
    warranty_status_result3:"已过期",

    // 文章
    article_seat1:"当前位置：首页",
    article_seat2:"资讯/文章",
    



    

}







//$t('offiaccount')